import React from 'react'

const PageInit: React.FC<void> = (): JSX.Element => {
    return <></>
}
export default PageInit
